import { useId } from 'react';
import { FacebookFollowLink } from './FacebookFollowLink';
import './SubcategoryBrowseFacebookInline.css';

/**
 * @param {{
 *   scopeLabel: string;
 *   location?: string;
 * }} props
 */
export function SubcategoryBrowseFacebookInline({
  scopeLabel,
  location = 'subcategory_browse',
}) {
  const headingId = useId();
  const name =
    typeof scopeLabel === 'string' && scopeLabel.trim() !== ''
      ? scopeLabel.trim()
      : 'this category';

  return (
    <li className="results-page__cell results-page__cell--facebook-inline">
      <aside
        className="browse-facebook-inline"
        aria-labelledby={headingId}
      >
        <div className="browse-facebook-inline__content">
          <p id={headingId} className="browse-facebook-inline__label">
            Follow on Facebook
          </p>
          <p className="browse-facebook-inline__lede">
            See{' '}
            <strong className="browse-facebook-inline__emphasis">
              {name} deals
            </strong>{' '}
            first — price drops, new local shops, and bargains we spot before
            they&apos;re gone.
          </p>
        </div>
        <FacebookFollowLink
          location={location}
          className="browse-facebook-inline__btn"
        />
      </aside>
    </li>
  );
}
